import {
  Badge,
  Fab,
  makeStyles,
  Modal,
  Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import ChatIcon from '@material-ui/icons/Chat';
import Fade from '@material-ui/core/Fade';
import CloseIcon from '@material-ui/icons/Close';
import { useRouteBasedConfig } from '../../util/routeBasedConfig';
import CustomChat from '../Chat/CustomChat';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: 21,
    right: 20,
    zIndex: 1000,
  },
  modal: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    inset: 'unset !important',
    bottom: '0 !important',
    right: '0 !important',
    width: '50% !important',
    height: '50% !important',
    maxWidth: 600,
    minWidth: 400,
    '@media (max-height:900px)': {
      height: '70% !important',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      height: '100% !important',
      minWidth: '100% !important',
    },
  },
  paper: {
    marginRight: 32,
    background: '#fff',
    maxWidth: 800,
    minWidth: 400,
    height: '100%',
    width: '100%',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    overflow: 'hidden',
    boxShadow: '0px -1px 16px 5px rgba(0,0,0,0.26)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginRight: 0,
      height: '90%',
      minWidth: '100%',
    },
  },
  header: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 8,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 8,
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  headerTitle: {
    flex: 1,
  },
  fab: {
    width: '60px',
    height: '60px',
    '&:hover': {
      background: theme.palette.secondary.main,
    },
  },
  wrapper: {
    height: '100%',
  },
  /* container for the active conversation - keeps header fixed, list scrollable and composer visible */
  messagesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    /* subtract top header (Chats) height - adjust 56px if your header is different */
    height: 'calc(100% - 45px)',
    width: '100%',
  },
  /* make the message list area grow and scroll */
  messagesList: {
    flex: 1,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    background: 'var(--cometchat-background-color-02, #f5f5f5)',
    '& .cometchat': {
      height: '100% !important',
    },
  },
  /* composer wrapper to keep it visible at bottom */
  composerContainer: {
    borderTop: '1px solid rgba(0,0,0,0.08)',
    padding: theme.spacing(1),
    background: 'var(--cometchat-background-color-01, #fff)',
  },
}));

// eslint-disable-next-line import/prefer-default-export
export function CustomChatModal() {
  const activeConfig = useRouteBasedConfig('customChat');
  const classes = useStyles();

  const [chatOpened, setChatOpened] = useState(false);

  if (
    !activeConfig
    || activeConfig.isVisible === false
  ) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Badge
        color="primary"
      >
        <Fab
          className={classes.fab}
          color="primary"
          size="large"
          hidden={chatOpened}
          onClick={() => setChatOpened(true)}
        >
          <ChatIcon className={classes.icon} />
        </Fab>
      </Badge>
      <Modal
        className={classes.modal}
        open={chatOpened}
        onClose={() => setChatOpened(false)}
        closeAfterTransition
        disableScrollLock
        BackdropComponent={() => null}
      >
        <Fade in={chatOpened}>
          <div className={classes.paper}>
            <div
              role="button"
              tabIndex={0}
              className={classes.header}
              onClick={() => setChatOpened(false)}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') setChatOpened(false);
              }}
            >
              <Typography className={classes.headerTitle}>Chat</Typography>
              <CloseIcon />
            </div>
            <div className={classes.messagesWrapper}>
              <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CustomChat />
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
